<template>
  <div>
    <app-head></app-head>
    <app-body>
      <div>
        <div class="about-us-background">
          <div class="banner-content-white-text">
            <h1 style="font-family: STCaiyun, Arial, sans-serif;">联系我们</h1>
            <hr>
            <p>
              您好！感谢您对我们的关注和支持。无论您是想了解更多信息、咨询产品服务，还是有任何合作意向，我们都期待与您沟通交流。<br>
              <strong>我们始终以客户需求为导向，致力于为您提供专业、高效、贴心的服务。期待与您携手共创美好未来！</strong>
            </p>
          </div>
          <div class="breadcrumb-container">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item>
                <router-link to="/"><i class="el-icon-house"></i> 首页</router-link>
              </el-breadcrumb-item>
              <el-breadcrumb-item>联系我们</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </div>
        <div class="contact-container">
          <div class="contact-us-container">
            <div class="contact-info">
              <div class="info-section" style="width: 310px">
                <h3>
                  <el-icon class="el-icon-location" style="font-size: 30px; color: #333;"></el-icon>
                  地址
                </h3>
                <p>{{ appForm.address }}</p>
              </div>

              <div class="info-section">
                <h3>
                  <el-icon class="el-icon-message" style="font-size: 30px; color: #333;"></el-icon>
                  邮箱
                </h3>
                <p>{{ appForm.email1 }}({{ appForm.emailPrincipals }})</p>
                <p>{{ appForm.email2 }}</p>
              </div>

              <div class="info-section">
                <h3>
                  <el-icon class="el-icon-phone-outline" style="font-size: 30px; color: #333;"></el-icon>
                  电话
                </h3>
                <p>{{ appForm.phone1 }}({{ appForm.phonePrincipals }})</p>
                <p>{{ appForm.phone2 }}</p>
              </div>
            </div>
          </div>
          <div class="contact-form">
            <h3>在线留言</h3>
            <el-form :model="form" :rules="rules" ref="formRef" label-position="top">
              <el-form-item prop="name" label="姓名">
                <el-input v-model="form.name" placeholder="姓名"></el-input>
              </el-form-item>

              <el-form-item prop="email" label="邮箱">
                <el-input v-model="form.email" placeholder="邮箱"></el-input>
              </el-form-item>

              <el-form-item prop="phone" label="电话">
                <el-input v-model="form.phone" placeholder="电话号码"></el-input>
              </el-form-item>
              <el-form-item prop="subject" label="主题">
                <el-select v-model="form.subject" placeholder="请选择主题">
                  <el-option label="了解更多" value="LEARN_MORE"></el-option>
                  <el-option label="产品服务" value="PRODUCT"></el-option>
                  <el-option label="合作意向" value="COOPERATION"></el-option>
                  <el-option label="意见反馈" value="FEEDBACK"></el-option>
                  <el-option label="加入我们" value="JOIN_US"></el-option>
                  <el-option label="其它" value="OTHER"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="content" label="留言">
                <el-input type="textarea" :rows="4" v-model="form.content" placeholder="留言"></el-input>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="submitForm" style="height: 50px">留言</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>

      </div>
    </app-body>
    <app-foot></app-foot>
  </div>
</template>


<script>
import AppHead from '../common/AppHeader.vue';
import AppBody from '../common/AppPageBody.vue'
import AppFoot from '../common/AppFoot.vue'

export default {
  name: "index",
  components: {
    AppHead,
    AppBody,
    AppFoot
  },
  data() {
    return {
      appForm: {
        phonePrincipals: '杨经理',
        phone1: '13929462171',
        phone2: '',
        emailPrincipals: '杨经理',
        email1: 'owen.yang@weste-group.com',
        email2: '',
        wechat: 'Jonhylulu',
        qq: '3319323391',
        address: '陕西省西安市长安区西沣路与郭杜西街十字西南角熙峰广场601A',
      },
      form: {
        name: '',
        email: '',
        phone: '',
        subject: '',
        content: ''
      },
      rules: {
        name: [{
          required: true,
          message: '请输入姓名',
          trigger: 'blur'
        }],
        email: [{
          required: true,
          message: '请输入邮箱',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: '请输入电话号码',
          trigger: 'blur'
        }],
        subject: [{
          required: true,
          message: '请选择主题',
          trigger: 'change'
        }],
        content: [{
          required: true,
          message: '请输入留言',
          trigger: 'blur'
        }]
      },
    };
  },
  created() {
    this.getForm();
    if (this.$route.query.subject) {
      this.form.subject = this.$route.query.subject;
    }
  },
  mounted() {
  },
  watch: {},
  methods: {
    getForm() {
      const item = sessionStorage.getItem("appInfo");
      if (item) {
        this.appForm = JSON.parse(item);
        return;
      }
      this.$api.getAppInfo().then(res => {
        if (res.code !== 200) {
          this.$message.error(res.message);
          return;
        }
        this.appForm = res.data;
        sessionStorage.setItem("appInfo", JSON.stringify(res.data));
      })
    },
    submitForm() {
      // 验证表单
      this.$refs.formRef.validate(valid => {
        if (valid) {
          // 提交表单
          this.submit();
        } else {
          this.$message.error('请正确填写表单');
          return false;
        }
      });
    },
    submit() {
      this.$api.contactUs(this.form).then(res => {
        if (res.code !== 200) {
          this.$message.error(res.message);
        }
        this.$message({
          message: '提交成功！管理员稍后会通过邮箱/电话向您取得联系!',
          type: 'success'
        })
      })
      // 重置表单
      this.form = {
        name: '',
        email: '',
        phone: '',
        content: '',
        subject: '',
      };
    }
  }
}
</script>

<style scoped>

.about-us-background {
  width: 100%;
  background-image: url("../../../assets/img/contact-bg.jpg");
  margin-top: -30px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  min-height: 500px
}

.banner-content-white-text {
  position: absolute;
  top: 40%;
  left: 50%;
  color: white;
  transform: translate(-50%, -50%);
  text-align: center;
}

/* 面包屑容器样式 */
.breadcrumb-container {
  position: absolute;
  left: 50%;
  bottom: 20px;
  transform: translateX(-50%); /* 水平居中 */
  background-color: rgba(255, 255, 255, 0.5); /* 半透明背景 */
  padding: 8px 16px;
  border-radius: 4px;
  width: auto;
  min-width: max-content;
}


.banner-content-white-text h1 {
  font-size: 36px;
  margin-bottom: 20px;
}

.contact-container {
  display: flex;
  max-width: 1000px;
  margin: 0 auto;
  padding: 100px;
  font-family: Arial, sans-serif;
}

.contact-info {
  flex: 1;
  padding-right: 40px;
  margin-top: 50px;
}

.info-section {
  margin-bottom: 60px;
}

.info-section h3 {
  color: #333;
  margin-bottom: 10px;
  font-size: 18px;
}

.info-section p {
  color: #666;
  margin: 5px 0;
  line-height: 1.5;
}

.contact-form {
  flex: 1;
}

.contact-form h3 {
  color: #333;
  margin-bottom: 20px;
  font-size: 18px;
}

.el-form-item {
  margin-bottom: 20px;
}

.el-button {
  width: 100%;
}

@media (max-width: 768px) {
  /* Banner */
  .about-us-background {
    min-height: 360px;
  }
  .banner-content-white-text {
    width: 90%;
  }
  .banner-content-white-text h1 {
    font-size: 28px;
    margin-bottom: 14px;
  }
  .banner-content-white-text p {
    font-size: 14px;
    line-height: 1.6;
    padding: 0 8px;
  }
  .breadcrumb-container {
    bottom: 12px;
    width: auto;
    min-width: max-content;
    max-width: 92%;
    padding: 6px 12px;
  }
  .breadcrumb-container .el-breadcrumb {
    display: inline-flex !important;
    flex-wrap: nowrap !important;
    font-size: 12px;
  }
  .breadcrumb-container .el-breadcrumb__item,
  .breadcrumb-container .el-breadcrumb__inner,
  .breadcrumb-container .el-breadcrumb__separator {
    white-space: nowrap !important;
    flex-shrink: 0 !important;
  }

  /* 联系内容区 */
  .contact-container {
    flex-direction: column;
    padding: 50px 16px;
  }
  .contact-info {
    padding-right: 0;
    margin-top: 0;
    margin-bottom: 30px;
  }
  .info-section {
    width: 100% !important;
    margin-bottom: 30px;
  }
  .info-section h3 {
    font-size: 16px;
  }
  .info-section p {
    font-size: 14px;
  }
  .contact-form h3 {
    font-size: 16px;
  }
}

</style>